import { AxiosInstance } from 'axios'
import type { FolderBreadcrumb } from '@dc-shared-web/hooks/api/folder/types'

type GetFolderForMoveQueryParams = {
  currentTeamUuid: string
  folderUuid: string
}

export const fetchFoldersById = async (
  apiClient: AxiosInstance,
  params: GetFolderForMoveQueryParams
): Promise<FolderBreadcrumb> => {
  const { data } = await apiClient.get(`/api/folders/${params.folderUuid}`, {
    params: {
      office_uuid: params.currentTeamUuid,
      limit: 500,
    },
  })
  return data
}
